<template>
  <div class="title-container">
    <img
      src="../../../../static/images/bargain/icon-back.png"
      alt=""
      class="icon-back"
      @click="handleBackPage"
    />
    <div class="title-text">{{ titleText ? titleText : "活动规则" }}</div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    username: String,
    titleText: String,
    curUrlKey: String
  },
  data() {
    return {};
  },
  components: {},
  methods: {
    handleBackPage() {
      const curUrlKey = this.curUrlKey;
      const username = this.username;

      switch (curUrlKey) {
        case "list": // 列表页跳转到首页
          location.href = `/wap_${this.username}.html`;
          break;
        case "bargaining": // 是否从订单页来，是的话返回订单页，否则跳转到列表页
          if (location.href.indexOf("order=1") > -1) {
            this.$router.go(-1);
          } else {
            this.$router.push({
              path: "/bargainList",
              query: { username }
            });
          }
          break;
        default:
          // 订单页规则页返回上一级
          this.$router.go(-1);
          break;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.title-container {
  position: relative;
  height: 1rem;
  width: 100%;
  background: #fff;
  z-index: 999;
  .title-text {
    text-align: center;
    line-height: 1rem;
    font-size: 0.34rem;
    color: #333;
  }
  .icon-back {
    position: absolute;
    left: 0.2rem;
    top: 50%;
    transform: translateY(-50%);
    width: 0.22rem;
    height: 0.37rem;
    padding: 0 0.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Bargain/components/Title.vue